import { type DiscountDetails } from '@libs/common-types';
import { CWEA_ENDPOINTS } from '../constants';
import { cweaClient } from '../clients/api-proxy-browser-client';

export async function getDiscountDetails(key: string): Promise<Nullable<DiscountDetails>> {
    const url = CWEA_ENDPOINTS.discounts.getDiscountDetails(key);
    return (
        (await cweaClient.get<Nullable<DiscountDetails>>(url, {
            withLocale: true,
            useOldFetch: true,
        })) ?? null
    );
}
